import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackContextDomainSubmitted.meta';

export type UseTrackContextDomainSubmittedParams = {
  domain: string;
  source: OnboardingAnalyticsCategory | 'manual';
};

export const useTrackContextDomainSubmitted = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextDomainSubmitted = useCallback(
    (params: UseTrackContextDomainSubmittedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextDomainSubmitted };
};
